<mat-panel-title>
  <img id="imgUserPicture" class="user-information-pic" src="{{userPicture}}" alt="User"/>
  <span class="user-information-name title" id="spUserName">{{ userName }}</span>
</mat-panel-title>